export const queryKeys = {
  activities: {
    list: (params = {}) => ['activities', 'list', params],
    detail: (activityId) => ['activities', 'detail', activityId],
  },
  events: {
    list: (params = {}) => ['events', 'list', params],
    detail: (eventId) => ['events', 'detail', eventId],
  },
  home: {
    overview: (communityId) => ['home', 'overview', communityId],
  },
  community: {
    meta: (scope) => ['community', 'meta', scope],
    stats: (scope) => ['community', 'stats', scope],
    lsa: (scope) => ['community', 'lsa', scope],
  },
  households: {
    list: (params = {}) => ['households', 'list', params],
    detail: (householdId) => ['households', 'detail', householdId],
  },
  notifications: {
    byUser: (scope) => ['notifications', 'user', scope],
  },
  news: {
    preview: (scope) => ['news', 'preview', scope],
    fullFeed: (scope) => ['news', 'full-feed', scope],
    recentComments: (scope) => ['news', 'recent-comments', scope],
    hasFetchedFullNews: (scope) => ['news', 'has-fetched-full', scope],
  },
  venues: {
    byCommunity: (communityId) => ['venues', 'community', communityId],
  },
  cachedResource: {
    byKey: (key) => ['cached-resource', key],
  },
  discover: {
    activities: (scope) => ['discover', 'activities', scope],
    events: (scope) => ['discover', 'events', scope],
    users: (scope) => ['discover', 'users', scope],
  },
  asyncResource: {
    byId: (id, version) => ['async-resource', id, version],
  },
};

export default queryKeys;
